<template>
  <div id="subscription-created" class="fill-height align-start" scrollable>
    <v-row class="g-container" no-gutters>
      <v-col cols="12" class="text-center mt-8 mt-md-16">
        <v-icon class="my-4">mdi-checkbox-marked-circle</v-icon>
        <h3>Well done!</h3>
        <p>
          Your <strong>{{ subscriptionStatusDisplayName }}</strong> subscription
          was successfully created in Stripe
        </p>
        <v-btn
          :to="{ name: 'dashboard' }"
          rounded
          class="i-btn-block-secondary my-4"
        >
          <strong>Go to Dashboard</strong>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters('profile', ['subscriptionStatusDisplayName']),
    ...mapState('preferences', ['selectedSupplierId'])
  },

  methods: {
    ...mapActions('profile', ['fetchSupplierProfile'])
  },

  mounted() {
    this.fetchSupplierProfile(this.selectedSupplierId)
  }
}
</script>

<style lang="scss" scoped>
#subscription-created {
  #content {
    .mdi:before {
      font-size: 48px;
      color: $secondary-color;
    }
  }
}

@media only screen and (min-width: 960px) {
  #subscription-created {
    .mdi:before {
      font-size: 64px;
    }
  }
}
</style>
